import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import { adminAPI } from '../../utils/api';

const AdminShell = ({ children, title, subtitle, actions }) => {
  const [dashData, setDashData] = useState(null);
  const [adminInfo, setAdminInfo] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    loadDashData();
  }, []);

  const loadDashData = async () => {
    try {
      const res = await adminAPI.getDashboard();
      setDashData(res.data.data);
    } catch (err) {
      if (err.response?.status === 401 && window.location.pathname !== '/admin') navigate('/admin');
    }
  };

  const badges = dashData ? {
    pending: dashData.students?.pending || 0,
    pendingSchools: dashData.schools?.pending || 0,
    tickets: 0,
    reviewQueue: 0
  } : {};

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#F7F8FC', fontFamily: "'Nunito', sans-serif" }}>
      <AdminSidebar badges={badges} adminInfo={adminInfo} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
        {/* Admin topbar */}
        <div style={{ background: 'white', borderBottom: '1px solid #E2E8F0', padding: '0 24px', height: '52px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: '15px', fontWeight: 800, color: '#1A1A2E' }}>{title || 'Admin Dashboard'}</div>
            {subtitle && <div style={{ fontSize: '11px', color: '#64748B', marginTop: '1px' }}>{subtitle}</div>}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {actions}
          </div>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminShell;
